<template>
  <div
    class="flex justify-between items-center border-b border-gray-400 p-4 w-full"
  >
    <div>
      <h3 class="font-bold pb-2">{{ crew.id }}</h3>

      <p class="text-sm">Supervisor: {{ crew.supervisor }}</p>
      <p class="text-sm">Leader: {{ crew.leader }}</p>
      <p class="text-sm" v-if="crew.laborers">
        {{ crew.laborers.length }} Laborers
      </p>
    </div>

    <context-menu
      :context-menu-items="contextMenuItems"
      @click.native.stop="shouldShowContextMenu = true"
    ></context-menu>
  </div>
</template>

<script>
import ContextMenu from "../../ContextMenu";
import { ContextMenuItem } from "../../../helper-classes/ContextMenuItem";

export default {
  name: "CrewCell",
  components: { ContextMenu },
  props: {
    crew: { type: Object, required: true }
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("edit", () => {
          this.$store.commit("setCreateEditComponentData", this.crew);
        }),
        new ContextMenuItem("delete", () => {
          console.log("Deleting this crew...");
        })
      ],
      shouldShowContextMenu: false
    };
  }
};
</script>

<style scoped></style>
